import React from 'react';
import Icon from '../../../components/AppIcon';

const ScenarioCard = ({ scenario }) => {
  const getScenarioColor = (type) => {
    const colors = {
      conservative: { bg: 'bg-error/10', text: 'text-error', icon: 'TrendingDown' },
      moderate: { bg: 'bg-warning/10', text: 'text-warning', icon: 'Minus' },
      optimistic: { bg: 'bg-success/10', text: 'text-success', icon: 'TrendingUp' }
    };
    return colors?.[type] || colors?.moderate;
  };

  const color = getScenarioColor(scenario?.scenario_type);

  return (
    <div className="bg-card rounded-xl p-6 border shadow-sm hover:shadow-md transition-all">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${color?.bg}`}>
            <Icon name={color?.icon} size={20} className={color?.text} strokeWidth={2} />
          </div>
          <h3 className="text-lg font-semibold text-foreground capitalize">
            {scenario?.scenario_type}
          </h3>
        </div>
        <div className={`px-3 py-1 rounded-full ${color?.bg}`}>
          <span className={`text-sm font-medium ${color?.text}`}>
            {scenario?.success_probability?.toFixed(0)}% Success
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <div>
          <p className="text-sm text-muted-foreground mb-1">Projected Total Savings</p>
          <p className="text-2xl font-bold text-foreground">
            ${scenario?.projected_total_savings?.toLocaleString()}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Monthly Income</p>
            <p className="text-lg font-semibold text-foreground">
              ${scenario?.projected_monthly_income?.toFixed(2)}
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Income Gap</p>
            <p className={`text-lg font-semibold ${
              scenario?.income_gap > 0 ? 'text-error' : 'text-success'
            }`}>
              ${Math.abs(scenario?.income_gap)?.toFixed(2)}
            </p>
          </div>
        </div>

        <div className="pt-3 border-t">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Years Until Depletion</span>
            <span className="text-sm font-semibold text-foreground">
              {scenario?.years_until_depletion} years
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioCard;